<template>
  <mds-combo-box
    :label="translate('scheduler.modal.performanceReport.label')"
    :data-set="performanceReportOptions"
    :selected-items="option"
    :disabled="!!queriedPerformanceReportId || !performanceReportOptions.length"
    :error="!performanceReportOptions.length"
    :errorText="[translate('scheduler.modal.performanceReport.error')]"
    @input="onChange"
  />
</template>
<script>
import isEmpty from 'lodash/isEmpty'
import MdsComboBox from '@mds/combo-box'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/schedulerModal/config/i18n'

export default {
  name: 'PerformanceReportOptions',
  components: {
    MdsComboBox,
  },
  props: {
    performanceReportParameters: {
      type: Array,
      default: /* istanbul ignore next */ () => [],
    },
    editedFeed: {
      type: Object,
      default: () => undefined,
    },
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      option: [],
      defaultConfig,
    }
  },
  created() {
    // Set the option to the saved value or the first element from the dropdown.
    this.option = this.selectSavedOrFirstOption
    this.$emit('input', { investment_item: this.option[0] })
  },
  watch: {
    performanceReportParameters() {
      this.option = this.selectSavedOrFirstOption
      const { text = '' } = this.performanceReportExists(this.option[0])
      this.$store.dispatch('setInvestmentItem', text)
      this.$emit('input', { investment_item: this.option[0] })
    },
  },
  computed: {
    queriedPerformanceReportId() {
      const { query = {} } = this.$route ?? {}
      const { id = undefined } = query

      const option = this.performanceReportExists(id)
      return option ? option.value : undefined
    },
    selectSavedOrFirstOption() {
      if (this.queriedPerformanceReportId) {
        return [this.queriedPerformanceReportId]
      }

      return this.savedOption ? this.savedOption : this.preselectedItem
    },
    savedOption() {
      // If the edited feed was initially an Investment List and then changed to a PR,
      // let's search by the ID to determine if the values match.
      const selectedOption = this.performanceReportExists(
        this.editedFeed?.investment_item
      )
      return selectedOption ? [selectedOption.value] : undefined
    },
    performanceReportOptions() {
      if (!this.performanceReportParameters) {
        return []
      }

      const [perfomanceReports = {}] = this.performanceReportParameters
      if (!perfomanceReports.options) {
        return []
      }

      const { morningstar = [], user = [] } =
        perfomanceReports.options.performance_report
      const reports = []

      if (morningstar.length) {
        reports.push(
          this.mapReport(
            'scheduler.modal.performanceReport.morningstar',
            morningstar
          )
        )
      }

      if (user.length) {
        reports.push(
          this.mapReport('scheduler.modal.performanceReport.user', user)
        )
      }
      return reports
    },
    preselectedItem() {
      for (const option of this.performanceReportOptions) {
        if (!isEmpty(option?.children)) {
          return [option.children[0].value]
        }
      }
      return []
    },
  },
  methods: {
    onChange(e) {
      this.option = e
      const { text = '' } = this.performanceReportExists(this.option[0])
      this.$store.dispatch('setInvestmentItem', text)
      this.$emit('input', { investment_item: e[0] })
    },
    mapReport(text, reportsArray) {
      return {
        text: this.translate(text),
        children: reportsArray.map((report) => ({
          value: report.id,
          text: report.name,
        })),
      }
    },
    performanceReportExists(performanceReportId) {
      const [performanceReports = {}] = this.performanceReportOptions
      return performanceReports?.children?.find(
        (option) => option.value === performanceReportId
      )
    },
  },
}
</script>
